import styled from 'styled-components';
import Notice from 'products/nomad_insurance/components/Notice';
import { sizes } from 'style';

export const Column = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media ${sizes.desktop} {
    gap: 24px;
  }
`;

export const CoverageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DesktopTitle = styled.h1`
  display: none;
  margin: 0;
  font-size: 32px;
  line-height: 40px;

  @media ${sizes.desktop} {
    display: block;
  }
`;

export const MobileTitle = styled.h1`
  margin: 0;
  margin-bottom: 4px;
  font-size: 24px;
  line-height: 32px;

  @media ${sizes.desktop} {
    display: none;
  }
`;
